// components/PopupWrapper.jsx
import React from "react";

function PopupWrapper({ children, onClose }) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
      onClick={onClose} // close when clicking outside
    >
      <div
        onClick={(e) => e.stopPropagation()} // prevent outside click
        style={{
          width: "700px",
          maxHeight: "90vh",
          overflowY: "auto",
          background: "#fff",
          borderRadius: "12px",
          padding: "0px",
          position: "relative",
          animation: "fadeIn 0.25s ease",
        }}
      >
        {children}
      </div>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: scale(0.95); }
            to { opacity: 1; transform: scale(1); }
          }
        `}
      </style>
    </div>
  );
}

export default PopupWrapper;
